import firebase from "firebase";

export const firebaseConfig = {
  apiKey: "AIzaSyB85P3bHq0q03s4qpayFPiTzcrqBJkTnkM",
  authDomain: "ayo-taxi.firebaseapp.com",
  databaseURL: "https://ayo-taxi.firebaseio.com",
  projectId: "ayo-taxi",
  storageBucket: "ayo-taxi.appspot.com",
  messagingSenderId: "968126680512",
  appId: "1:968126680512:web:c511ad38a4352f5b",
  measurementId: "G-RZ9YYY1YTP",
};

firebase.initializeApp(firebaseConfig);

export default firebase;
